import React, { Component } from "react";
import { Form, Input, Button } from "antd";
import { validate } from "validate.js";
import { urlValidationRule } from "../shared/TrackedWebsites/TrackedWebsitesWizard/validators";
import CompetitorsTable from "./CompetitorsTable";

const InputGroup = Input.Group;

export class CompetitorsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      competitorUrl: "",
      validationError: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isAddingCompetitors && !this.props.isAddingCompetitors) {
      this.setState({ competitorUrl: "" });
    }
    if (prevProps.mainUrl !== this.props.mainUrl) {
      this.setState({ competitorUrl: "", validationError: "" });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    let competitorUrl = this.state.competitorUrl.toLowerCase().trim();
    if (this.props.mainUrl === competitorUrl) {
      this.setState({ validationError: "The competitor URL must be different than the main URL!" });
      return;
    }
    const validationError = validate({ url: competitorUrl }, urlValidationRule);
    if (this.props.competitors.includes(competitorUrl)) {
      this.setState({ validationError: "This competitor is already added to your list!" });
      return;
    }
    if (!validationError) {
      this.setState({ validationError: "" });
      let updatedCompetitorsSetting = { competitors: [...this.props.competitors, competitorUrl] };
      this.props.updateCompetitors(this.props.domain, updatedCompetitorsSetting, "addCompetitor");
    } else {
      this.setState({ validationError: validationError.url });
    }
  }

  handleInputChange(event) {
    let competitorUrl = event.target.value;
    this.setState({ competitorUrl, validationError: "" });
  }

  render() {
    return (
      <div className="competitors-tab">
        <Form onSubmit={this.handleSubmit}>
          <Form.Item
            validateStatus={this.state.validationError ? "error" : "success"}
            help={this.state.validationError}>
            <InputGroup compact size="large">
              <div className="compact-input-group">
                <Input
                  name="competitorUrl"
                  value={this.state.competitorUrl}
                  onChange={this.handleInputChange}
                  placeholder="Add new competitor url"
                  size="large"
                />

                <Button
                  type="primary"
                  htmlType="submit"
                  icon="plus"
                  size="large"
                  disabled={this.props.competitors.length >= this.props.maxCompetitorsNo}
                  loading={this.props.isAddingCompetitors}>
                </Button>
              </div>
            </InputGroup>
          </Form.Item>
        </Form>

        {this.props.competitors.length > 0 ? (
          <CompetitorsTable
            domain={this.props.domain}
            competitors={this.props.competitors}
            competitorBeingDeleted={this.props.competitorBeingDeleted}
            updateCompetitors={this.props.updateCompetitors}
          />
        ) : null}
      </div>
    );
  }
}

export default CompetitorsTab;
